import client from '@/api/base';

export default {
// OA Dashboard
  async getOaProgress() {
    const response = await client.get('coaching/org/dashboard/progress/');
    return response;
  },

  async getOaPulse() {
    const response = await client.get('coaching/org/dashboard/pulse/');
    return response;
  },

  async getOaBase() {
    const response = await client.get('coaching/org/dashboard/base/');
    return response;
  },

  async getOaEngagement() {
    const response = await client.get('coaching/org/dashboard/engagement/');
    return response;
  },

  async getOaCvc() {
    const response = await client.get('coaching/org/dashboard/cvc/');
    return response;
  },
};
